import cep from 'cep-promise';

export interface CepAddressResult {
  street: string;
  neighborhood: string;
  city: string;
  state: string;
}

export async function fetchAddressByCep(cepValue: string): Promise<CepAddressResult> {
  const digits = cepValue.replace(/\D/g, '');
  if (digits.length !== 8) {
    throw new Error('CEP inválido');
  }

  const result = await cep(digits);
  return {
    street: result.street ?? '',
    neighborhood: result.neighborhood ?? '',
    city: result.city ?? '',
    state: result.state ?? '',
  };
}
